import * as z from "zod";
import {
  automationSummarySchema,
  diagnosticSchema,
  versionDetailSchema,
} from "./common";

/**
 * Freezes the draft into the next version and turns the automation on, unless
 * it has errors. A draft changed since `draftRevision` is a conflict, so
 * nobody publishes a draft they haven't seen.
 */
export const publish = {
  name: "publish" as const,
  input: z.object({
    id: z.string(),
    /** The draftRevision the editor loaded or last saved. */
    draftRevision: z.string(),
  }),
  output: z.discriminatedUnion("ok", [
    z.object({
      ok: z.literal(true),
      automation: automationSummarySchema,
      version: versionDetailSchema,
    }),
    z.object({
      ok: z.literal(false),
      message: z.string(),
      diagnostics: z.array(diagnosticSchema),
    }),
  ]),
};
